<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Auditoria</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            { text: 'Home', disabled: false, to: '/home', exact: true },
                            { text: 'Auditoria', disabled: true, exact: true },
                        ]"></v-breadcrumbs>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-tabs v-model="activeTab" background-color="transparent" class="mb-4">
                    <v-tab>Log de Acoes</v-tab>
                    <v-tab>Alteracoes em Registros</v-tab>
                    <v-tab>Viagens por Administrador</v-tab>
                </v-tabs>

                <v-tabs-items v-model="activeTab">
                    <!-- ABA 1: LOG DE ACOES (audit_logs) -->
                    <v-tab-item>
                        <v-card class="filter-card mb-4">
                            <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                            <v-card-text>
                                <v-form @submit.prevent="loadLogs()">
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <v-select dense label="Metodo" v-model="logList.filter.method"
                                                :items="methods" item-text="text" item-value="value"
                                                hide-details outlined clearable></v-select>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field dense label="Endpoint" v-model="logList.filter.url"
                                                placeholder="Ex: trips" hide-details outlined></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field dense label="Data inicio" v-model="logList.filter.date_start"
                                                type="date" hide-details outlined></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field dense label="Data fim" v-model="logList.filter.date_end"
                                                type="date" hide-details outlined></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-btn type="submit" color="primary" dark elevation="2">Aplicar filtros</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>

                        <v-card>
                            <v-card-text>
                                <v-data-table :headers="logList.headers" :items="logList.data"
                                    @update:items-per-page="logPageSizeChanged" @update:page="logPageChanged"
                                    :server-items-length="logList.count" :disable-sort="true"
                                    :loading="logList.loading"
                                    no-data-text="Nenhum log encontrado"
                                    loading-text="Carregando dados..."
                                    class="app-table hover-table" :options.sync="logList.options"
                                    :footer-props="logList.footerOptions">

                                    <template v-slot:[`item.created_at`]="{ item }">
                                        <span>{{ formatDate(item.created_at) }}</span>
                                    </template>

                                    <template v-slot:[`item.user`]="{ item }">
                                        <span>{{ item.user ? item.user.name : 'N/A' }}</span>
                                    </template>

                                    <template v-slot:[`item.method`]="{ item }">
                                        <v-chip small :color="getMethodColor(item.method)" dark>
                                            {{ item.method }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:[`item.url`]="{ item }">
                                        <span class="text-caption">{{ item.url }}</span>
                                    </template>

                                    <template v-slot:[`item.status_code`]="{ item }">
                                        <v-chip small :color="item.status_code < 300 ? 'green' : 'orange'" dark>
                                            {{ item.status_code }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:[`item.actions`]="{ item }">
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" @click="viewLogDetails(item)" size="large">
                                                    mdi-eye-outline
                                                </v-icon>
                                            </template>
                                            <span>Ver detalhes</span>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <!-- ABA 2: ALTERACOES EM REGISTROS (audits) -->
                    <v-tab-item>
                        <v-card class="filter-card mb-4">
                            <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                            <v-card-text>
                                <v-form @submit.prevent="loadAudits()">
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <v-select dense label="Modulo" v-model="auditList.filter.auditable"
                                                :items="modules" item-text="text" item-value="value"
                                                hide-details outlined clearable></v-select>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-select dense label="Acao" v-model="auditList.filter.event"
                                                :items="events" item-text="text" item-value="value"
                                                hide-details outlined clearable></v-select>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field dense label="Data inicio" v-model="auditList.filter.date_start"
                                                type="date" hide-details outlined></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field dense label="Data fim" v-model="auditList.filter.date_end"
                                                type="date" hide-details outlined></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <v-text-field dense label="ID do registro" v-model="auditList.filter.auditable_id"
                                                hide-details outlined></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-btn type="submit" color="primary" dark elevation="2">Aplicar filtros</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>

                        <v-card>
                            <v-card-text>
                                <v-data-table :headers="auditList.headers" :items="auditList.data"
                                    @update:items-per-page="auditPageSizeChanged" @update:page="auditPageChanged"
                                    :server-items-length="auditList.count" :disable-sort="true"
                                    :loading="auditList.loading"
                                    no-data-text="Nenhum registro de auditoria encontrado"
                                    loading-text="Carregando dados..."
                                    class="app-table hover-table" :options.sync="auditList.options"
                                    :footer-props="auditList.footerOptions">

                                    <template v-slot:[`item.created_at`]="{ item }">
                                        <span>{{ formatDate(item.created_at) }}</span>
                                    </template>

                                    <template v-slot:[`item.user`]="{ item }">
                                        <span>{{ item.user ? item.user.name : 'Sistema' }}</span>
                                    </template>

                                    <template v-slot:[`item.auditable`]="{ item }">
                                        <v-chip small :color="getModuleColor(item.auditable)" dark>
                                            {{ translateModule(item.auditable) }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:[`item.event`]="{ item }">
                                        <v-chip small :color="getEventColor(item.event)" dark>
                                            {{ translateEvent(item.event) }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:[`item.summary`]="{ item }">
                                        <span class="audit-summary">{{ getAuditSummary(item) }}</span>
                                    </template>

                                    <template v-slot:[`item.actions`]="{ item }">
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" @click="viewAuditDetails(item)" size="large">
                                                    mdi-eye-outline
                                                </v-icon>
                                            </template>
                                            <span>Ver detalhes</span>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <!-- ABA 3: VIAGENS LANCADAS POR ADMINISTRADOR -->
                    <v-tab-item>
                        <v-card class="filter-card mb-4">
                            <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                            <v-card-text>
                                <v-form @submit.prevent="loadTripStats()">
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <v-text-field dense label="Data inicio" v-model="tripStats.filter.date_start"
                                                type="date" hide-details outlined></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field dense label="Data fim" v-model="tripStats.filter.date_end"
                                                type="date" hide-details outlined></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-btn type="submit" color="primary" dark elevation="2">Aplicar filtros</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>

                        <v-card>
                            <v-card-title class="filter-card-title">
                                Total de viagens lancadas: {{ tripStats.total }}
                                <v-spacer></v-spacer>
                                <v-btn color="success" elevation="0" :loading="tripStats.exporting"
                                    :disabled="!tripStats.data.length" @click="exportTripStats">
                                    <v-icon left small>mdi-file-excel-outline</v-icon>
                                    Exportar
                                </v-btn>
                            </v-card-title>
                            <v-card-text>
                                <v-data-table :headers="tripStats.headers" :items="tripStats.data"
                                    :loading="tripStats.loading" :disable-pagination="true" hide-default-footer
                                    sort-by="total" :sort-desc="true"
                                    no-data-text="Nenhuma viagem lancada no periodo"
                                    loading-text="Carregando dados..."
                                    class="app-table hover-table">

                                    <template v-slot:[`item.share`]="{ item }">
                                        <span>{{ formatShare(item.total) }}</span>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>

        <!-- MODAL DETALHES LOG DE ACAO -->
        <v-dialog v-model="logDetailDialog" max-width="800px" scrollable>
            <v-card v-if="selectedLog">
                <v-card-title>
                    <v-icon class="mr-2">mdi-text-box-search-outline</v-icon>
                    Log #{{ selectedLog.id }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="logDetailDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <v-row>
                        <v-col cols="6">
                            <strong>Administrador:</strong> {{ selectedLog.user ? selectedLog.user.name : 'N/A' }}
                        </v-col>
                        <v-col cols="6">
                            <strong>Data/Hora:</strong> {{ formatDate(selectedLog.created_at) }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <strong>Metodo:</strong>
                            <v-chip small :color="getMethodColor(selectedLog.method)" dark>{{ selectedLog.method }}</v-chip>
                        </v-col>
                        <v-col cols="3">
                            <strong>Status:</strong>
                            <v-chip small :color="selectedLog.status_code < 300 ? 'green' : 'orange'" dark>{{ selectedLog.status_code }}</v-chip>
                        </v-col>
                        <v-col cols="3">
                            <strong>IP:</strong> {{ selectedLog.ip }}
                        </v-col>
                        <v-col cols="3">
                            <strong>URL:</strong> {{ selectedLog.url }}
                        </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <h4 class="mb-2">Dados da requisicao</h4>
                    <v-card outlined class="pa-3" style="max-height: 400px; overflow-y: auto;">
                        <pre class="diff-content">{{ formatJson(selectedLog.request_data) }}</pre>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="logDetailDialog = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL DETALHES ALTERACAO -->
        <v-dialog v-model="auditDetailDialog" max-width="900px" scrollable>
            <v-card v-if="selectedAudit">
                <v-card-title>
                    <v-icon class="mr-2">mdi-shield-search</v-icon>
                    Alteracao #{{ selectedAudit.id }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="auditDetailDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <v-row>
                        <v-col cols="6">
                            <strong>Administrador:</strong> {{ selectedAudit.user ? selectedAudit.user.name : 'Sistema' }}
                        </v-col>
                        <v-col cols="6">
                            <strong>Data/Hora:</strong> {{ formatDate(selectedAudit.created_at) }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <strong>Modulo:</strong> {{ translateModule(selectedAudit.auditable) }}
                        </v-col>
                        <v-col cols="4">
                            <strong>Acao:</strong>
                            <v-chip small :color="getEventColor(selectedAudit.event)" dark>{{ translateEvent(selectedAudit.event) }}</v-chip>
                        </v-col>
                        <v-col cols="4">
                            <strong>ID Registro:</strong> {{ selectedAudit.auditable_id }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6"><strong>IP:</strong> {{ selectedAudit.ip }}</v-col>
                        <v-col cols="6"><strong>URL:</strong> {{ selectedAudit.url }}</v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>

                    <v-alert dense text :color="getEventColor(selectedAudit.event)" class="mb-4">
                        {{ getAuditSummary(selectedAudit) }}
                    </v-alert>

                    <div v-if="selectedAudit.event === 'update'">
                        <h4 class="mb-3">O que foi alterado</h4>
                        <v-simple-table dense class="audit-change-table">
                            <template #default>
                                <thead>
                                    <tr>
                                        <th>Campo</th>
                                        <th>Antes</th>
                                        <th>Depois</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="change in getAuditChanges(selectedAudit)" :key="change.key">
                                        <td class="font-weight-medium">{{ change.label }}</td>
                                        <td>{{ change.before }}</td>
                                        <td>{{ change.after }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <v-alert v-if="getAuditChanges(selectedAudit).length === 0" dense text type="info" class="mt-3">
                            Nenhuma diferenca relevante foi identificada para exibicao.
                        </v-alert>
                    </div>

                    <div v-else-if="selectedAudit.event === 'create'">
                        <h4 class="mb-3">Informacoes registradas</h4>
                        <v-simple-table dense class="audit-change-table">
                            <template #default>
                                <thead>
                                    <tr>
                                        <th>Campo</th>
                                        <th>Valor informado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="change in getAuditChanges(selectedAudit)" :key="change.key">
                                        <td class="font-weight-medium">{{ change.label }}</td>
                                        <td>{{ change.after }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>

                    <div v-else-if="selectedAudit.event === 'delete'">
                        <h4 class="mb-3">Registro removido</h4>
                        <v-simple-table dense class="audit-change-table">
                            <template #default>
                                <thead>
                                    <tr>
                                        <th>Campo</th>
                                        <th>Valor que estava salvo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="change in getAuditChanges(selectedAudit)" :key="change.key">
                                        <td class="font-weight-medium">{{ change.label }}</td>
                                        <td>{{ change.before }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>

                    <v-expansion-panels flat class="mt-4">
                        <v-expansion-panel>
                            <v-expansion-panel-header>Ver dados tecnicos</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row v-if="selectedAudit.event === 'update'">
                                    <v-col cols="6">
                                        <h4 class="mb-2">Dados anteriores</h4>
                                        <v-card outlined class="pa-3 audit-json-box">
                                            <pre class="diff-content">{{ formatJson(selectedAudit.old_data) }}</pre>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="6">
                                        <h4 class="mb-2">Dados novos</h4>
                                        <v-card outlined class="pa-3 audit-json-box">
                                            <pre class="diff-content">{{ formatJson(selectedAudit.new_data) }}</pre>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row v-else-if="selectedAudit.event === 'create'">
                                    <v-col cols="12">
                                        <h4 class="mb-2">Dados criados</h4>
                                        <v-card outlined class="pa-3 audit-json-box">
                                            <pre class="diff-content">{{ formatJson(selectedAudit.new_data) }}</pre>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row v-else-if="selectedAudit.event === 'delete'">
                                    <v-col cols="12">
                                        <h4 class="mb-2">Dados removidos</h4>
                                        <v-card outlined class="pa-3 audit-json-box">
                                            <pre class="diff-content">{{ formatJson(selectedAudit.old_data) }}</pre>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="auditDetailDialog = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios';

// Horarios da auditoria sempre exibidos no horario de Brasilia
const TIMEZONE = 'America/Sao_Paulo';

const MODULE_LABELS = {
    Trip: 'Viagem',
    TripPassenger: 'Passageiro da Viagem',
    TripPassengerPoint: 'Ponto do Passageiro',
    TripRequest: 'Solicitacao de Viagem',
    TripRequestPoint: 'Ponto da Solicitacao',
    TripRecurrence: 'Recorrencia',
    User: 'Usuario',
    Role: 'Papel',
    RolePermission: 'Permissao do Papel',
    Vehicle: 'Veiculo',
    Driver: 'Motorista',
    Passenger: 'Passageiro',
    Customer: 'Empresa',
    Requester: 'Solicitante',
    CostCenter: 'Centro de Custo',
    Location: 'Local',
    Itinerary: 'Itinerario',
    Toll: 'Pedagio',
    Holiday: 'Feriado',
    TimeInterval: 'Intervalo',
    Maintenance: 'Manutencao',
    MaintenanceScheduling: 'Programacao de Manutencao',
    PartStock: 'Estoque de Pecas',
    Supplier: 'Fornecedor',
    Service: 'Servico (legado)',
};

const EVENT_LABELS = {
    create: 'Criacao',
    update: 'Atualizacao',
    delete: 'Exclusao',
};

const FIELD_LABELS = {
    id: 'Codigo',
    name: 'Nome',
    description: 'Descricao',
    email: 'E-mail',
    phone: 'Telefone',
    phone_number: 'Telefone',
    registration: 'Matricula',
    document: 'Documento',
    rg: 'RG',
    password: 'Senha',
    address: 'Endereco',
    number: 'Numero',
    complement: 'Complemento',
    district: 'Bairro',
    city: 'Cidade',
    state: 'Estado',
    status: 'Status',
    type: 'Tipo',
    date: 'Data',
    time: 'Horario',
    value: 'Valor',
    total_value: 'Valor total',
    distance: 'Distancia',
    duration: 'Duracao',
    observation: 'Observacao',
    reason: 'Motivo',
    justification: 'Justificativa',
    vehicle_id: 'Veiculo',
    driver_id: 'Motorista',
    passenger_id: 'Passageiro',
    customer_id: 'Empresa',
    requester_id: 'Solicitante',
    cost_center_id: 'Centro de custo',
    trip_id: 'Viagem',
    trip_request_id: 'Solicitacao de viagem',
    itinerary_id: 'Itinerario',
    itinerary_name: 'Nome do itinerario',
    origin_address: 'Endereco de origem',
    destination_address: 'Endereco de destino',
    origin_city: 'Cidade de origem',
    destination_city: 'Cidade de destino',
    origin_state: 'Estado de origem',
    destination_state: 'Estado de destino',
    latitude: 'Latitude',
    longitude: 'Longitude',
    created_at: 'Criado em',
    updated_at: 'Atualizado em',
    deleted_at: 'Excluido em',
    blocked: 'Bloqueado',
    active: 'Ativo',
    color_id: 'Cor',
    vehicle_model_id: 'Modelo do veiculo',
    plate: 'Placa',
    model: 'Modelo',
    brand: 'Marca',
    year: 'Ano',
};

const HIDDEN_FIELDS = ['updated_at'];
const SENSITIVE_FIELDS = ['password', 'token', 'refresh_token', 'refreshToken'];
const TRIP_STATUS_LABELS = {
    1: 'Pendente',
    2: 'Cancelada',
    3: 'Finalizada',
    4: 'Em andamento',
    5: 'Confirmada',
};
const TRIP_PASSENGER_STATUS_LABELS = {
    1: 'Pendente',
    2: 'Finalizado',
    3: 'Nao embarcou',
};
const TRIP_REQUEST_STATUS_LABELS = {
    1: 'Pendente',
    2: 'Aprovada',
    3: 'Rejeitada',
    4: 'Finalizada',
};
const TRIP_TYPE_LABELS = {
    1: 'Entrada',
    2: 'Saida',
    3: 'Personalizada',
};

export default {
    name: 'AuditList',

    data: () => ({
        activeTab: 0,

        modules: Object.entries(MODULE_LABELS).map(([value, text]) => ({ value, text })),
        events: Object.entries(EVENT_LABELS).map(([value, text]) => ({ value, text })),
        methods: [
            { text: 'POST (Criar)', value: 'POST' },
            { text: 'PATCH (Atualizar)', value: 'PATCH' },
            { text: 'PUT (Atualizar)', value: 'PUT' },
            { text: 'DELETE (Excluir)', value: 'DELETE' },
        ],

        // Aba 1: Log de Acoes
        logList: {
            filter: {},
            headers: [
                { text: 'Data/Hora', value: 'created_at', width: '170px' },
                { text: 'Administrador', value: 'user' },
                { text: 'Metodo', value: 'method', width: '110px' },
                { text: 'Endpoint', value: 'url' },
                { text: 'Status', value: 'status_code', width: '90px' },
                { text: 'IP', value: 'ip', width: '130px' },
                { text: 'Detalhes', value: 'actions', sortable: false, width: '90px' },
            ],
            data: [],
            loading: false,
            count: 0,
            options: { page: 1, size: 20 },
            footerOptions: {
                itemsPerPageText: 'Itens por pagina:',
                itemsPerPageOptions: [10, 20, 50, 100],
                pageText: '{0}-{1} de {2}',
            },
        },
        logDetailDialog: false,
        selectedLog: null,

        // Aba 2: Alteracoes em Registros
        auditList: {
            filter: {},
            headers: [
                { text: 'Data/Hora', value: 'created_at', width: '170px' },
                { text: 'Administrador', value: 'user' },
                { text: 'Modulo', value: 'auditable' },
                { text: 'Acao', value: 'event', width: '130px' },
                { text: 'ID Registro', value: 'auditable_id', width: '110px' },
                { text: 'Resumo', value: 'summary' },
                { text: 'IP', value: 'ip', width: '130px' },
                { text: 'Detalhes', value: 'actions', sortable: false, width: '90px' },
            ],
            data: [],
            loading: false,
            count: 0,
            options: { page: 1, size: 20 },
            footerOptions: {
                itemsPerPageText: 'Itens por pagina:',
                itemsPerPageOptions: [10, 20, 50, 100],
                pageText: '{0}-{1} de {2}',
            },
        },
        auditDetailDialog: false,
        selectedAudit: null,

        // Aba 3: Viagens por Administrador
        tripStats: {
            filter: {},
            headers: [
                { text: 'Administrador', value: 'name' },
                { text: 'Viagens lancadas', value: 'total', width: '180px' },
                { text: '% do total', value: 'share', sortable: false, width: '140px' },
            ],
            data: [],
            total: 0,
            loading: false,
            exporting: false,
        },
    }),

    created() {
        this.loadLogs();
    },

    watch: {
        activeTab(val) {
            if (val === 0 && this.logList.data.length === 0) this.loadLogs();
            if (val === 1 && this.auditList.data.length === 0) this.loadAudits();
            if (val === 2 && this.tripStats.data.length === 0) this.loadTripStats();
        },
    },

    methods: {
        // --- Log de Acoes ---
        logPageChanged(page) {
            this.logList.options.page = page;
            this.loadLogs();
        },
        logPageSizeChanged(size) {
            this.logList.options.size = size;
            this.loadLogs();
        },
        async loadLogs() {
            this.logList.loading = true;
            try {
                const params = {
                    page: this.logList.options.page,
                    limit: this.logList.options.size,
                    search: { ...this.logList.filter },
                };
                const result = await axios.get('api/v2/audits/logs', { params });
                this.logList.data = result.data.data;
                this.logList.count = result.data.total;
            } catch (error) {
                console.error('Erro ao carregar logs:', error);
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.logList.loading = false;
            }
        },
        viewLogDetails(item) {
            this.selectedLog = item;
            this.logDetailDialog = true;
        },

        // --- Alteracoes em Registros ---
        auditPageChanged(page) {
            this.auditList.options.page = page;
            this.loadAudits();
        },
        auditPageSizeChanged(size) {
            this.auditList.options.size = size;
            this.loadAudits();
        },
        async loadAudits() {
            this.auditList.loading = true;
            try {
                const params = {
                    page: this.auditList.options.page,
                    limit: this.auditList.options.size,
                    search: { ...this.auditList.filter },
                };
                const result = await axios.get('api/v2/audits', { params });
                this.auditList.data = result.data.data;
                this.auditList.count = result.data.total;
            } catch (error) {
                console.error('Erro ao carregar auditoria:', error);
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.auditList.loading = false;
            }
        },
        viewAuditDetails(item) {
            this.selectedAudit = item;
            this.auditDetailDialog = true;
        },

        // --- Viagens por Administrador ---
        async loadTripStats() {
            if (!this.tripStats.filter.date_start && !this.tripStats.filter.date_end) {
                this.tripStats.filter = this.getCurrentMonthRange();
            }

            this.tripStats.loading = true;
            try {
                const params = { search: { ...this.tripStats.filter } };
                const result = await axios.get('api/v2/audits/trips-by-admin', { params });
                this.tripStats.data = result.data.data;
                this.tripStats.total = result.data.total;
            } catch (error) {
                console.error('Erro ao carregar viagens por administrador:', error);
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.tripStats.loading = false;
            }
        },
        async exportTripStats() {
            this.tripStats.exporting = true;
            try {
                const response = await axios.get('api/v2/audits/trips-by-admin/export', {
                    params: { search: { ...this.tripStats.filter } },
                    responseType: 'blob',
                });
                const { date_start: start, date_end: end } = this.tripStats.filter;
                const period = [start, end].filter(Boolean).join('-a-');
                const link = document.createElement('a');
                link.href = URL.createObjectURL(new Blob([response.data]));
                link.download = `viagens-por-administrador${period ? `-${period}` : ''}.xlsx`;
                link.click();
                URL.revokeObjectURL(link.href);
            } catch (error) {
                console.error('Erro ao exportar viagens por administrador:', error);
                this.$dialog.notify.error('Nao foi possivel exportar', { position: 'top-right', timeout: 5000 });
            } finally {
                this.tripStats.exporting = false;
            }
        },
        getCurrentMonthRange() {
            // Data de hoje no horario de Brasilia, no formato YYYY-MM-DD
            const today = new Intl.DateTimeFormat('en-CA', { timeZone: TIMEZONE }).format(new Date());
            const [year, month] = today.split('-');
            return { date_start: `${year}-${month}-01`, date_end: today };
        },
        formatShare(total) {
            if (!this.tripStats.total) return '0%';
            return `${((total / this.tripStats.total) * 100).toFixed(1).replace('.', ',')}%`;
        },

        // --- Utilitarios ---
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);

            if (Number.isNaN(d.getTime())) {
                return date;
            }

            return new Intl.DateTimeFormat('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false,
                timeZone: TIMEZONE,
            }).format(d);
        },
        formatJson(data) {
            if (!data) return 'N/A';
            try {
                if (typeof data === 'string') data = JSON.parse(data);
                return JSON.stringify(data, null, 2);
            } catch {
                return String(data);
            }
        },
        translateModule(auditable) {
            return MODULE_LABELS[auditable] || auditable;
        },
        translateEvent(event) {
            return EVENT_LABELS[event] || event;
        },
        getEventColor(event) {
            return { create: 'green', update: 'orange darken-1', delete: 'red' }[event] || 'grey';
        },
        getMethodColor(method) {
            return { POST: 'green', PATCH: 'orange darken-1', PUT: 'blue', DELETE: 'red' }[method] || 'grey';
        },
        getModuleColor(auditable) {
            if (auditable && auditable.startsWith('Trip')) return 'blue darken-1';
            if (auditable === 'User' || auditable === 'Role') return 'purple';
            if (auditable === 'Vehicle') return 'teal';
            if (auditable === 'Driver') return 'indigo';
            return 'blue-grey';
        },
        getAuditSummary(audit) {
            const moduleName = this.translateModule(audit.auditable).toLowerCase();
            const actorName = audit.user ? audit.user.name : 'Sistema';
            const changes = this.getAuditChanges(audit);

            if (audit.event === 'create') {
                return `${actorName} criou um registro em ${moduleName}.`;
            }

            if (audit.event === 'delete') {
                return `${actorName} removeu um registro de ${moduleName}.`;
            }

            if (audit.event === 'update') {
                if (!changes.length) {
                    return `${actorName} atualizou um registro de ${moduleName}, sem diferencas relevantes para exibicao.`;
                }

                const fields = changes.slice(0, 3).map((change) => change.label).join(', ');
                const suffix = changes.length > 3 ? ` e mais ${changes.length - 3} campo(s)` : '';
                return `${actorName} alterou ${fields}${suffix} em ${moduleName}.`;
            }

            return `${actorName} realizou uma acao em ${moduleName}.`;
        },
        getAuditChanges(audit) {
            const oldData = this.normalizeAuditData(audit.old_data);
            const newData = this.normalizeAuditData(audit.new_data);
            const keys = this.getAuditFieldKeys(oldData, newData, audit.event);

            return keys.map((key) => ({
                key,
                label: this.translateField(key),
                before: this.formatAuditValue(oldData[key], key, audit),
                after: this.formatAuditValue(newData[key], key, audit),
            })).filter((change) => {
                if (audit.event !== 'update') return true;
                return change.before !== change.after;
            });
        },
        normalizeAuditData(data) {
            if (!data) return {};

            if (typeof data === 'string') {
                try {
                    return JSON.parse(data) || {};
                } catch {
                    return {};
                }
            }

            if (typeof data === 'object') {
                return data;
            }

            return {};
        },
        getAuditFieldKeys(oldData, newData, event) {
            const source = event === 'delete' ? oldData : { ...oldData, ...newData };

            return Object.keys(source)
                .filter((key) => !HIDDEN_FIELDS.includes(key))
                .filter((key) => !(event !== 'update' && this.isEmptyAuditValue(source[key])))
                .filter((key) => event !== 'update' || !this.areAuditValuesEqual(oldData[key], newData[key]))
                .sort((a, b) => this.translateField(a).localeCompare(this.translateField(b)));
        },
        translateField(field) {
            if (FIELD_LABELS[field]) return FIELD_LABELS[field];

            return field
                .replace(/_id$/, '')
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (letter) => letter.toUpperCase());
        },
        formatAuditValue(value, key, audit) {
            if (SENSITIVE_FIELDS.includes(key)) return 'Informacao protegida';
            if (value === null || value === undefined || value === '') return 'Nao informado';
            if (typeof value === 'boolean') return value ? 'Sim' : 'Nao';
            if (value === 1 && ['blocked', 'active'].includes(key)) return 'Sim';
            if (value === 0 && ['blocked', 'active'].includes(key)) return 'Nao';
            if (key === 'status') return this.formatStatusValue(value, audit);
            if (key === 'type') return this.formatTypeValue(value, audit);
            if (key && key.endsWith('_id')) return `Codigo ${value}`;
            if (['value', 'total_value'].includes(key)) return this.formatMoney(value);
            if (key === 'distance') return `${value} km`;
            if (key === 'duration') return `${value} min`;

            if (key && key.endsWith('_at')) {
                return this.formatDate(value);
            }

            if (key === 'date') {
                return this.formatShortDate(value);
            }

            if (typeof value === 'object') {
                if (value.name) return value.name;
                if (value.description) return value.description;
                if (value.id) return `Codigo ${value.id}`;
                return JSON.stringify(value);
            }

            return String(value);
        },
        formatStatusValue(value, audit) {
            const moduleStatusLabels = {
                Trip: TRIP_STATUS_LABELS,
                Service: TRIP_STATUS_LABELS,
                TripPassenger: TRIP_PASSENGER_STATUS_LABELS,
                TripRequest: TRIP_REQUEST_STATUS_LABELS,
            };
            const labels = moduleStatusLabels[audit.auditable];

            return labels && labels[value] ? labels[value] : String(value);
        },
        formatTypeValue(value, audit) {
            if (audit.auditable === 'Trip') {
                return TRIP_TYPE_LABELS[value] || String(value);
            }

            return String(value);
        },
        formatMoney(value) {
            const number = Number(value);

            if (Number.isNaN(number)) {
                return String(value);
            }

            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(number);
        },
        formatShortDate(value) {
            if (!value) return 'Nao informado';

            if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
                const [year, month, day] = value.split('-');
                return `${day}/${month}/${year}`;
            }

            const date = new Date(value);

            if (Number.isNaN(date.getTime())) {
                return String(value);
            }

            return new Intl.DateTimeFormat('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                timeZone: TIMEZONE,
            }).format(date);
        },
        areAuditValuesEqual(left, right) {
            return this.formatComparableValue(left) === this.formatComparableValue(right);
        },
        formatComparableValue(value) {
            if (value === null || value === undefined || value === '') return '';
            if (typeof value === 'object') return JSON.stringify(value);
            return String(value);
        },
        isEmptyAuditValue(value) {
            return value === null || value === undefined || value === '';
        },
    },
};
</script>

<style scoped>
.diff-content {
    font-size: 12px;
    white-space: pre-wrap;
    word-break: break-all;
    font-family: monospace;
    margin: 0;
}

.audit-summary {
    display: block;
    max-width: 420px;
    line-height: 1.35;
}

.audit-change-table {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
}

.audit-change-table td,
.audit-change-table th {
    vertical-align: top;
}

.audit-json-box {
    max-height: 400px;
    overflow-y: auto;
}
</style>
